import getDeliveryStatusByPriority from "../../src/api/articles/getDeliveryStatusByPriority";

function mapStatusesByDeliveryType({ channels, channelIds, deliveryType }) {
	return Object.entries(channels || {})
		.filter(([channelId]) => channelIds.includes(channelId))
		.map(([_, channel]) => {
			return channel.delivery?.[deliveryType]?.status;
		});
}

export default function createArticleDelivery({ channels, channelIds }) {
	const artifactStatuses = mapStatusesByDeliveryType({ channels, channelIds, deliveryType: "artifact" });
	const metadataStatuses = mapStatusesByDeliveryType({ channels, channelIds, deliveryType: "metadata" });

	const artifactStatus = getDeliveryStatusByPriority(artifactStatuses);
	const metadataStatus = getDeliveryStatusByPriority(metadataStatuses);

	return {
		artifact: {
			status: artifactStatus,
		},
		metadata: {
			status: metadataStatus,
		},
		status: getDeliveryStatusByPriority([artifactStatus, metadataStatus]),
	};
}
